import includes from 'lodash/includes';
import find from 'lodash/find';
import size from 'lodash/size';

export default organizations => {
  let country = null;

  if (!size(organizations)) return null;

  if (find(organizations, item => includes(item, 'Flagler'))) {
    country = 'USA';
  }

  return country;
};



// WEBPACK FOOTER //
// ./src/utils/handleUserData/checkCountryForOrganization.js